
import Header from '../../components/layout/Header';
import Footer from '../../components/layout/Footer';

const areas = [
  {
    id: 'yoyogiuehara',
    name: '代々木上原',
    mapSrc:
      'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3241.7!2d139.6836!3d35.6617!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x6018f34b2e3b3b3b%3A0x0!2z5Luj3Yq55LiK5Y6f6aeF!5e0!3m2!1sja!2sjp!4v1',
  },
  {
    id: 'yoyogikouen',
    name: '代々木公園',
    mapSrc:
      'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3241.9!2d139.6942!3d35.6636!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x6018f34b2e3b3b3b%3A0x0!2z5Luj3Yq55YWs5ZyS6aeF!5e0!3m2!1sja!2sjp!4v1',
  },
  {
    id: 'okushibuya',
    name: '奥渋谷',
    mapSrc:
      'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3241.5!2d139.6980!3d35.6580!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x6018f33b2e3b3b3b%3A0x0!2z5riL6LC35Y6f!5e0!3m2!1sja!2sjp!4v1',
  },
];

export default function Access() {
  return (
    <div className="min-h-screen bg-white">
      <Header />

      <main className="pt-32 pb-24">
        <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8">

          {/* Page Title */}
          <div className="text-center mb-10">
            <h1 className="text-4xl md:text-5xl font-bold text-gray-800 mb-2 tracking-tight">
              Access
            </h1>
            <p className="text-pink-500 text-xl">アクセス</p>
          </div>

          {/* エリア大見出し */}
          <div className="text-center mb-14">
            <p className="text-sm text-gray-400 uppercase tracking-widest mb-3">出張対応エリア</p>
            <p className="text-3xl md:text-4xl font-bold text-gray-800 leading-snug">
              代々木上原 / 代々木公園 / 奥渋谷
            </p>
          </div>

          {/* エリアカード */}
          <div className="grid md:grid-cols-3 gap-6 mb-14">
            {areas.map((area) => (
              <div
                key={area.id}
                className="rounded-2xl border border-pink-100 shadow-sm overflow-hidden bg-white hover:shadow-md transition-shadow duration-200"
              >
                <div className="bg-gradient-to-r from-pink-50 to-rose-50 px-5 py-3 border-b border-pink-100">
                  <h2 className="text-lg font-bold text-gray-800 text-center">{area.name}</h2>
                </div>
                <div className="w-full h-56">
                  <iframe
                    src={area.mapSrc}
                    width="100%"
                    height="100%"
                    style={{ border: 0 }}
                    allowFullScreen
                    loading="lazy"
                    referrerPolicy="no-referrer-when-downgrade"
                    title={`${area.name}エリアマップ`}
                    className="block"
                  />
                </div>
              </div>
            ))}
          </div>

          {/* 補足情報 */}
          <div className="bg-gradient-to-br from-pink-50 to-rose-50 rounded-2xl p-8 mb-12">
            <div className="flex items-start gap-2.5">
              <div className="w-5 h-5 flex items-center justify-center flex-shrink-0 mt-0.5">
                <i className="ri-checkbox-circle-fill text-pink-400 text-base"></i>
              </div>
              <p className="text-gray-600 text-sm leading-relaxed">
                各エリアともに徒歩圏内の好立地からご案内いただけます。
              </p>
            </div>
          </div>

          {/* CTA */}
          <div className="text-center">
            <a
              href="https://r.caskan.jp/jdspa"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center px-12 py-5 bg-gradient-to-r from-pink-500 to-pink-400 text-white text-lg rounded-full font-semibold hover:shadow-xl transition-all duration-200 cursor-pointer whitespace-nowrap"
            >
              <div className="w-7 h-7 flex items-center justify-center mr-3">
                <i className="ri-calendar-check-line text-2xl"></i>
              </div>
              WEB予約はこちら
            </a>
          </div>

        </div>
      </main>

      <Footer />
    </div>
  );
}
